import { createStyles } from '@mantine/emotion';

export const useStyles = createStyles(() => ({
  container: {
    width: '100%',
    backgroundColor: 'transparent',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    gap: 4
  },
  nameWrapper: {
    textOverflow: 'ellipsis',
    overflow: 'hidden'
  }
}));
